import React, { useState, useEffect } from "react";
import {
  Divider,
  Typography,
  Button,
  TableContainer,
  Table,
  IconButton,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
} from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ReactComponent as DeleteIcon } from "../../../Icons/DeleteTable.svg";
import { ReactComponent as EditIcon } from "../../../Icons/EditIcon.svg";
import AlertModal from "../../../CommonComponents/AlertModal";
import LinearProgress from '@mui/material/LinearProgress';
import CachedIcon from '@mui/icons-material/Cached';
import axiosInstance from "../../../api/axiosInstance";
import { useDispatch } from "react-redux";
import { removeData } from "../../../Redux/Feature/AdminSlice";

function CheckListMain() {
  const navigate = useNavigate();
  const dispatch = useDispatch()

  const [page, setPage] = useState(0); // Initialize to 0 for zero-based indexing
  const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

  const [checklistData, setCheckListData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0); // State to hold the total count of items
  const [deleteModal, setDeleteModal] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  let deleteData = {
    label: "Confirm Delete Checklist",
    descriptionOne: "Please confirm that you wish to delete the checklist.",
    buttonOne: {
      variant: "outlined",
      color: "#0E5E84",
      backgroundColor: "#FFFFFF",
      text: "Cancel",
    },
    buttonTwo: {
      variant: "contained",
      color: "#FFFFFF",
      backgroundColor: "#912018",
      text: "Confirm",
    },
  };

  // Function to fetch paginated data from the API
  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}get-check-list?page=${
          page + 1
        }&limit=${rowsPerPage}`
      );
      console.log("Get all checklist:", response.data);
      setCheckListData(response.data.data || []);
      setTotalItems(response.data.pagination.totalItems || 0);
      setLoading(false) 
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  // Fetch data whenever page or rowsPerPage changes
  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage]);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to first page when rows per page change
  };

  const handleClose = () => {
    setDeleteModal(null);
    setDeleteId(null);
  };

  const deleteCheckList = async () => {
    try {
      await axiosInstance.delete(
        `${process.env.REACT_APP_API_URL}delete-check-list/${deleteId}`
      );
      fetchData();
      setDeleteModal(null);
      setDeleteId(null);
    } catch (error) {
      console.log(error);
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };


  return (
    <>
      {deleteModal && (
        <AlertModal
          modalDatas={deleteData}
          confirmFunction={deleteCheckList}
          closeFunction={handleClose}
        />
      )}

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems : 'center'}}>
        <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
          Checklist
        </Typography>

        <Box sx={{display : 'flex', gap : 3, alignItem : 'center'}}>
        <Typography variant="h7_1" sx={{cursor : 'pointer'}} title='Reload' onClick={() => fetchData()}><CachedIcon /></Typography>
        <Button
          variant='contained'
          onClick={() => navigate("/Admin/AddCheckList")}
        >
          Add
        </Button>
        </Box>
      </Box>
      {/* <Divider sx={{ mb: 3.5 }} /> */}
      <TableContainer
        sx={{
          mt : 2.5,
          borderRadius: "5px",
          border: "1px solid #e5e5e5",
          boxShadow: "0px 0px 30px 20px #f4f4f4",
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow sx={{ backgroundColor: "white" }}>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                  Product
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                  Price
                </Typography>
              </TableCell>
              <TableCell sx={{ borderBottom: "0.5px solid #dcdddc", py: 2.7 }}>
                <Typography variant="h9_1" color="#333333">
                  Actions
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loading && (
              <TableRow>
                <TableCell colSpan={5} sx={{p :0, borderBottom : '0px'}}>
              <LinearProgress color="primary" />
              </TableCell>
              </TableRow>
            )}

            {checklistData.length == 0 ? (<>
              <TableRow>
              <TableCell colSpan={5} sx={{borderBottom: "0.5px solid #dcdddc", py: 2.7}}>
            {!loading && (
            <Typography>No data found</Typography>
            )}
            </TableCell>
            </TableRow>
            </>) : (
          checklistData.map((item, index) => (
              <TableRow
                key={index}
                sx={{
                  border: "0px",
                  backgroundColor: index % 2 === 0 ? "#f8f8f8" : "white", 
                }}
              >
                <TableCell
                  sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}
                >
                  <Typography variant="h9_4">
                    {item?.item?.en || "-"}
                  </Typography>
                </TableCell>
                <TableCell
                  sx={{ minWidth: "200px", borderBottom: "0.5px solid #dcdddc" }}
                >
                  <Typography variant="h9_4">
                    S$ {item?.price || "-"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ borderBottom: "0.5px solid #dcdddc" }}>
                  <IconButton
                    onClick={() => navigate(`/Admin/edit-checklist/${item._id}`)}
                    sx={{ marginRight: "10px" }}
                  >
                    <EditIcon fill="black" />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setDeleteId(item._id);
                      setDeleteModal(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            )))}
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={totalItems} 
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </TableContainer>
    </>
  );
}

export default CheckListMain;
